import { render, staticRenderFns } from "./OverlayMessageParts.vue?vue&type=template&id=d678f096&scoped=true"
import script from "./OverlayMessageParts.vue?vue&type=script&lang=ts"
export * from "./OverlayMessageParts.vue?vue&type=script&lang=ts"
import style0 from "./OverlayMessageParts.vue?vue&type=style&index=0&id=d678f096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d678f096",
  null
  
)

export default component.exports